import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDetailEmployee } from "../../../../apis/System/employee.api";

const employeeRoleStyle = {
  margin: "40px",
};

const EmployeeDetail = () => {
  const { id } = useParams();
  const [employeeDetail, setEmployeeDetail] = useState({});

  useEffect(() => {
    getDetailEmployee(id, (result) => {
      setEmployeeDetail(result);
    });
  }, [id]);

  return (
    <div>
      <div className="page-header">
        <h2>Employee Detail</h2>
      </div>
      <h1>{employeeDetail.fullName}</h1>
      <span>{`email: ${employeeDetail.email}`}</span>

      <div style={employeeRoleStyle}>
        <h3>** department</h3>
        <h5 style={employeeRoleStyle}>{employeeDetail?.department?.name}</h5>
      </div>
      <div style={employeeRoleStyle}>
        <h3>** Roles</h3>
        {employeeDetail?.roles?.map((role) => (
          <h5 key={role.id} style={employeeRoleStyle}>
            {role.name.toLowerCase()}
          </h5>
        ))}
      </div>
      <div style={employeeRoleStyle}>
        <h3>** Permissions:</h3>
        {employeeDetail?.permissions?.map((permission) => (
          <h5 key={permission.id} style={employeeRoleStyle}>
            {permission.name.toLowerCase()}
          </h5>
        ))}
      </div>
    </div>
  );
};

export default EmployeeDetail;
